import {
	BARE_COMMENT_ROW_CLASS,
	COMMENT_BODY_INDENT_CLASS,
} from "@productlane/ui/src/components/slack-style-message-surface"

// The composer repeats the avatar and gap of a comment row, so what you type starts on
// the same column as the comment body above it.
export const COMMENT_COMPOSER_AVATAR_SIZE = "s" as const
export const COMMENT_COMPOSER_INDENT_CLASS = COMMENT_BODY_INDENT_CLASS
// Buttons as tall as the avatar, so a one-line composer is exactly one avatar high.
export const COMMENT_COMPOSER_ACTION_SIZE = "md" as const

export const commentComposerLayout = {
	container: BARE_COMMENT_ROW_CLASS,
	// Avatar at the top, send button at the bottom once the text wraps to several lines.
	row: "flex items-start gap-3",
	// Flex drops the inline avatar's text line box, which otherwise makes the row 30px tall.
	avatar: "flex flex-none",
	// One line is exactly one avatar high, so the bottom-pinned buttons share the avatar's line.
	editor:
		"min-w-0 flex-1 [&_.ProseMirror]:!leading-6 [&_.ProseMirror_p]:!my-0 [&_.ProseMirror_p]:!py-0 [&_.ProseMirror_p]:!leading-6",
	actions: "flex h-6 flex-none items-center gap-1 self-end",
}
